import React, { useEffect, useState } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import relogio from "../../icons/icon_relogio.svg"
import "./calendar.css"
import { Service } from '../../service'
import { SimpleBadge } from '../simpleBadge'
import { Button } from '../button'
import { Title } from '../title'
import MyWorkWeek from '../customWeekView/index.tsx'


require('moment/locale/pt-br.js');
const localizer = momentLocalizer(moment);

const EventComponent = ({ event, method = (evt) => { } }) => {
    if (event.title === "Turma fechada") {
        return <div onClick={(evt) => evt.stopPropagation()} className='aula-status aula-completa'>{event.title} <span className='spaces'>{event.capacity}</span></div>
    }
    return <>
        <div onClick={(evt) => { evt.stopPropagation(); method(event, evt) }} className='aula-status aula-aberta'>{event.title} <span className='spaces'>{event.ocupation}/{event.capacity}</span></div>
    </>
}

export const Calendario = ({ isMobile = false, modalidade, unidade, onReturn = (calendarData) => { console.log(calendarData) } }) => {

    var horariosPassados = [];

    const today = new Date()
    const days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

    const [events, setEvents] = useState([])
    const [filteredEvents, setFilteredEvents] = useState([])
    const [popupOpen, setPopupOpen] = useState(0);
    const [selectedEvent, setSelectedEvent] = useState({});
    const [coords, setCoords] = useState({ x: 0, y: 0 });
    const [selectedDay, setSelectedDay] = useState(today.getDay());
    const [selectedDate, setSelectedDate] = useState(today.toISOString().split('T')[0]);

    useEffect(() => {
        (async () => {
            let activities = await Service.getActivities();
            setEvents(activities);
        })()
    }, [modalidade, unidade]);

    useEffect(() => {
        if (events.length > 0) {
            let fevents = events.filter(evt => evt.title === modalidade || (evt.title === "Turma fechada" && evt?.refer === modalidade));
            horariosPassados = [];
            fevents = fevents.map(fe => {
                return { ...fe, ...Service.setCalendarTime(fe, horariosPassados) }
            });
            setFilteredEvents(fevents);
        }
    }, [events])

    const eventSelected = (event, evt) => {
        setPopupOpen(event.idConfiguration);
        setSelectedEvent(event);
        setCoords({ x: window.innerWidth < 767 ? (window.innerWidth - 300) / 2 : evt.pageX, y: evt.pageY - 80 });
    }

    const SelectDay = () => {

        let cWeek = [new Date(today.getTime())]
        for (var i = 1; i < days.length; i++) {
            let nd = new Date(cWeek[cWeek.length - 1].getTime());
            nd.setDate(nd.getDate() + 1);
            cWeek.push(nd);
        }

        return <div className='day-row'>
            <div>
                <div>
                    {cWeek.map((day, key) => {
                        return <button key={key} onClick={(e) => { setSelectedDay(day.getDay()); setSelectedDate(day.toISOString().split("T")[0]) }} index={key} className={`day-button ${day.getDay() === selectedDay ? "selected" : ""}`}>
                            <span>{days[day.getDay()]}</span>
                            <b>{day.getDate() < 10 ? "0" + day.getDate() : day.getDate()}</b>
                        </button>
                    })}
                </div>
            </div>
        </div>
    }

    const EventGrid = () => {
        let events = [...filteredEvents];
        events = filteredEvents.filter(event => {
            return event.activityDate.includes(selectedDate)
        }
        );

        return <div className='event-grid w-100'>
            <div>
                {events.length > 0 && events.map((event, key) => {
                    return <div key={key} className={`${event.title === "Turma fechada" ? "fechado" : ""} ${Object.keys(selectedEvent).length > 0 && selectedEvent.idConfiguration === event.idConfiguration ? "selected" : ""} d-flex w-100`} onClick={(e) => { if (event.title !== "Turma fechada") { setSelectedEvent(event); onReturn(event) } }}>
                        <div className='p-1'>
                            <b>{event.startString.split(" ")[0]}</b>
                        </div>
                        <div className='p-1'>
                            <b className='d-block'>{event.title}</b>
                            <span className='d-block capitalize'>{event.instructor}</span>
                        </div>
                    </div>
                }) || <p>Ops, parece que não há aulas para este dia.</p>}
            </div>
        </div>
    }

    const CalendarComponents = {
        header: ({ date }) => <><font style={{ display: "block" }} onClick={(evt) => evt.stopPropagation()}><span>{days[moment(date).day()]}</span><b>{moment(date).date()}</b></font></>,
        event: ({ event }) => {
            return <EventComponent event={event} popup={popupOpen} method={eventSelected} />
        },
    }

    const EventPopup = () => {
        if (popupOpen !== 0 && popupOpen === selectedEvent?.idConfiguration) {
            return <>
                <div className='event-popup' style={{ position: "absolute", left: coords.x, top: coords.y }}>
                    <a className='close-popup' onClick={() => setPopupOpen(0)}>&times;</a>
                    <img src={selectedEvent.imageUrl} />
                    <div>
                        <div>
                            <SimpleBadge text={selectedEvent.title} />
                            {selectedEvent.activityDate.split("T")[0].split("-").reverse().join("/")}
                        </div>
                        <div>
                            <span>Início: {selectedEvent.startTime}</span>
                            <span>Fim: {selectedEvent.endTime}</span>
                        </div>
                        <p>Prof. {selectedEvent.instructor}</p>
                        <Button text={"Selecionar"} onClick={() => { onReturn(selectedEvent); setPopupOpen(0) }} />
                    </div>
                </div>
            </>
        }
        return <></>
    }

    return <div className='calendar-agendamento'>
        {/*<img src={relogio} className="icon" alt="icone-relogio" />*/}
        <Title text={"Selecione a data e o horário"} />
        {!isMobile && <h3 style={{ fontWeight: 400 }}>
            As aulas experimentais disponíveis estão na cor <SimpleBadge text={"verde"} /> no calendário abaixo.
        </h3>}
        {isMobile && <h5 style={{ fontWeight: 400 }}>
            As aulas na cor <SimpleBadge text={"vermelha"} status='negative' /> não estão disponíveis para agendamento.
        </h5>}
        <br />
        {isMobile && <div className='h-75'>
            <SelectDay />
            <EventGrid />
        </div>}

        {!isMobile && <Calendar
            localizer={localizer}
            components={CalendarComponents}
            events={filteredEvents}
            startAccessor="start"
            endAccessor="end"
            defaultView='myweek'
            views={{
                day: true,
                month: true,
                week: true,
                myweek: MyWorkWeek,
            }}
            style={{ height: 855 }}
            min={moment('6:00am', 'h:mma').toDate()}
            max={moment('10:59pm', 'h:mma').toDate()}
            step={20}
            timeslots={3}
            dayLayoutAlgorithm="no-overlap"
            messages={{
                next: "Próximo",
                previous: "Anterior",
                today: "Hoje",
                month: "Mês",
                week: "Semana",
                day: "Dia",
            }}
        />}
        <EventPopup event={selectedEvent} popup={popupOpen} method={setPopupOpen} />
    </div>
}